import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";
import GoogleButton from "../components/GoogleButton";

const SignupPage: React.FC = () => {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);

  const handleSignUpError = (err: Error) => {
    const errorMessage = err?.message || t("signupPage.googleSignUpError");
    setError(errorMessage);
  };

  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      <Header />
      <main className="flex-grow flex items-center justify-center">
        <div className="w-full max-w-md px-6 py-12">
          <h2 className="text-4xl font-bold mb-8 text-center text-white">
            {t("signupPage.title")}
          </h2>

          {error && (
            <div className="mb-4 p-4 bg-red-900 bg-opacity-50 text-red-300 rounded-lg border border-red-800">
              {error}
            </div>
          )}

          <div className="w-full mb-6">
            <GoogleButton
              textKey="googleButton.signUp"
              onError={handleSignUpError}
            />
          </div>

          <div className="mt-6 text-center">
            <p className="text-gray-400">
              {t("signupPage.hasAccountPrompt")}
              <Link
                to="/login"
                className="text-gray-300 hover:text-white underline transition-colors"
              >
                {t("signupPage.loginLink")}
              </Link>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SignupPage;
